import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from './layout/AppLayout';
import { Login } from './screens/Login';
import { Register } from './screens/Register';
import { VerifyEmail, ForgotPassword, ResetPassword } from './screens/AuthFlows';
import { Overview } from './screens/Overview';
import { Analytics } from './screens/Analytics';
import { ApiKeys } from './screens/ApiKeys';
import { Wallet } from './screens/Wallet';
import { FiatAccount } from './screens/FiatAccount';
import { Rates } from './screens/Rates';
import { UsdPayouts } from './screens/UsdPayouts';
import { OwedOfframps } from './screens/OwedOfframps';
import { FailedOnramps } from './screens/FailedOnramps';
import { Onramps, Offramps } from './screens/Orders';
import { Counterparties } from './screens/Counterparties';
import { CounterpartyDetail } from './screens/CounterpartyDetail';
import { Ledger } from './screens/Ledger';
import { Webhooks } from './screens/Webhooks';
import { Logs } from './screens/Logs';
import { Docs } from './screens/Docs';
import { Settings } from './screens/Settings';
import { Team } from './screens/Team';
import { Projects } from './screens/Projects';

/**
 * Route table — the single place paths are declared.
 *
 * Authenticated screens are nested under AppLayout, which also acts as the
 * guard, so adding a page never means remembering to add an auth check.
 */
export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/register', element: <Register /> },
  { path: '/verify-email', element: <VerifyEmail /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/reset-password', element: <ResetPassword /> },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <Overview /> },
      { path: 'wallet', element: <Wallet /> },
      { path: 'fiat', element: <FiatAccount /> },
      { path: 'usd', element: <UsdPayouts /> },
      { path: 'rates', element: <Rates /> },
      { path: 'analytics', element: <Analytics /> },
      { path: 'onramps', element: <Onramps /> },
      { path: 'offramps', element: <Offramps /> },
      { path: 'owed-offramps', element: <OwedOfframps /> },
      { path: 'failed-onramps', element: <FailedOnramps /> },
      { path: 'counterparties', element: <Counterparties /> },
      { path: 'counterparties/:address', element: <CounterpartyDetail /> },
      { path: 'ledger', element: <Ledger /> },
      { path: 'api-keys', element: <ApiKeys /> },
      { path: 'webhooks', element: <Webhooks /> },
      { path: 'logs', element: <Logs /> },
      { path: 'team', element: <Team /> },
      { path: 'projects', element: <Projects /> },
      { path: 'docs', element: <Docs /> },
      { path: 'settings', element: <Settings /> },
    ],
  },
]);
